import { toast } from "react-toastify";
import { Divider, Typography } from "@mui/material";
import React from "react";
// eslint-disable-next-line import/no-cycle
import useStore from "../../store";
import PTMBottomAppBar from "../../Components/PTMBottomAppBar";

function Notification(props) {
    const {
        data: {
            title,
            subtitle,
            message,
            openTab,
            reload,
            button,
        },
    } = props;

    const dashboardAddTab = useStore.getState().dashboard.addTab;

    return (
        <>
            <Typography variant="subtitle2">{title}</Typography>
            {subtitle && (<Typography variant="subtitle">{subtitle}</Typography>)}
            {message && (<Divider />)}
            {message && (
                <Typography
                    style={{
                        display: "block", maxHeight: 150, maxWidth: 260, overflow: "auto",
                    }}
                    variant="body"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
            {openTab && (
                <PTMBottomAppBar buttons={[
                    {
                        name: openTab?.buttonText || "In Tab öffnen",
                        color: "success",
                        icon: "folder-open",
                        click: () => dashboardAddTab({
                            icon: openTab.icon,
                            title: openTab.title,
                            plugin: openTab.plugin,
                            component: openTab.component,
                            data: {
                                id: openTab.id,
                            },
                        }),
                    },
                ]}
                />
            )}
            {reload && (
                <PTMBottomAppBar buttons={[
                    {
                        name: "Neu laden",
                        color: "success",
                        icon: "sync-alt",
                        // eslint-disable-next-line no-restricted-globals
                        click: () => location.reload(),
                    },
                ]}
                />
            )}
            {button && (
                <PTMBottomAppBar buttons={[
                    {
                        name: button.title,
                        color: button.color || "success",
                        icon: button.icon,
                        click: button.click,
                    },
                ]}
                />
            )}
        </>
    );
}

const notify = ({ options = {}, data = {} }, action = null) => {
    const defaults = {
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    };

    if (options?.hideNotifications !== undefined) {
        defaults.autoClose = options.hideNotifications ? defaults.autoClose : false;
    }

    if (action === "loading") {
        return toast.loading(Notification, {
            ...defaults,
            ...options,
            data,
        });
    }

    // if toast not active, skip update and create new toast
    if (action === "update" && toast.isActive(options.toastId)) {
        return toast.update(options.toastId, {
            render: Notification,
            ...defaults,
            ...options,
            data,
        });
    }

    // // same as update, but always settings isLoading: false
    // if (action === "stopLoading" && toast.isActive(options.toastId)) {
    //     return toast.update(options.toastId, {
    //         render: Notification,
    //         ...defaults,
    //         ...options.options,
    //         data: options.data,
    //         isLoading: false,
    //     });
    // }

    return toast(Notification, {
        ...defaults,
        ...options,
        data,
    });
};

export default notify;
